import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { LHRVimeo } from '../../shared';

Builder.registerComponent(LHRVimeo, {
  name: BUILDER_DIVIDER_NAMES.ReasonsLHRVimeo,
});
